import {showErrorMessage} from '@/helper';

export const visibleAMLQuestionnaireResultKeys = ['BUSINESS_RELATIONSHIP_ESTABLISHED', 'CLIENT_RISK_PROFILE', 'PRODUCT_RISK_CATEGORY', 'CLIENT_CHECK_INTENSITY'];

export default {
    fetchRecords(clientId, body) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/aml-questionnaires/list`, {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAll() {
        return new Promise((resolve, reject) => {
            http.get('api/aml-questionnaires').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveQuestionnaire(clientId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/aml-questionnaires' + (data.id ? '/' + data.id : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(error.response.data);
            });
        });
    },

    countResult(clientId, questionnaireId, data) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/aml-questionnaires${questionnaireId ? '/' + questionnaireId : ''}/evaluate-preview`, data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(error.response.data);
            });
        });
    },

    getInvestmentQuestionnaireQuestions() {
        return new Promise((resolve, reject) => {
            http.get('api/aml-questionnaires/questions').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteRecord(clientId, recordId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/aml-questionnaires/' + recordId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getUsers() {
        return new Promise((resolve, reject) => {
            http.get('api/users').then(response => {
                resolve(response.data.users);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getUser(id) {
        return new Promise((resolve, reject) => {
            http.get('api/users/' + id).then(response => {
                resolve(response.data.user);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },

    saveQuestionnaireWithBankID(clientId, recordId, bankIdCode) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/aml-questionnaires/${recordId}/save-with-bank-id`, {code: bankIdCode}).then(response => {
                localStorage.removeItem('AML_QUESTIONNAIRE_ID');
                window.location.href = 'home';
                resolve(response.data);
            }).catch(error => {
                localStorage.removeItem('AML_QUESTIONNAIRE_ID');
                window.location.href = 'home';
                reject(error.response.data);
            });
        });
    }
}
